/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AiResponse } from '@squiz/dxp-ai-client';
import { getCapabilityPath } from 'apps/console-core/src/Utilities/GetCapabilityPath/GetCapabilityPath';
import { NavigateFunction } from 'react-router-dom';
import { isGenerative } from '../../../Utilities/formPredicates';
import { getContentToolPath } from '../../../Utilities/getContentToolPath';

export function navigateToAiListItem(ai: AiResponse, navigate: NavigateFunction): void {
  const currentScreenPath = getCapabilityPath(`/`);

  if (isGenerative(ai.type)) {
    const viewContentToolPath = `${currentScreenPath}ai-content-tool${getContentToolPath(ai.id)}`;
    navigate({ pathname: viewContentToolPath });
  } else {
    const viewChatBotPath = `${currentScreenPath}ai-chatbots${getContentToolPath(ai.id)}`;
    navigate({ pathname: viewChatBotPath });
  }
}
